import React from 'react';

import { CardTitle, CardTitleIcon, CardTitleText, Container } from './styles';

interface CardProps {
  title?: string;
  iconName?: string;
}

const Card: React.FC<CardProps> = ({ children, title, iconName, ...props }) => {
  return (
    <>
      {title && (
        <CardTitle>
          {iconName && <CardTitleIcon name={iconName} />}
          <CardTitleText>{title}</CardTitleText>
        </CardTitle>
      )}
      <Container {...props}>{children}</Container>
    </>
  );
};

export default Card;
